<template>
  <div>
    <a
      v-if="$router.currentRoute._value.name != 'home'"
      title="Revenir"
      href="javascript:history.go(-1)"
      class="btn btn-breadcrumb"
    >
      <i
        class="fa fa-chevron-left"
        aria-hidden="true"
      />
    </a>
    <div
      v-for="route in breadCrumbRoutes"
      :key="route.id"
      class="btn font-custom"
    >
      <router-link
        :to="{name: route.name}"
        class="btn-breadcrumb"
      >
        {{ route.label }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      breadCrumbRoutes: [],
      routesMap: new Map([
        ['password-change', []],
        ['distributor-list', []],
        ['distributor-edit', ['distributor-list']],
        ['affiliate-list', []],
        ['affiliate-detail', ['affiliate-list']],
        ['affiliate-edit', ['affiliate-list']],
        ['authorization-list', []],
        ['authorization-detail', ['authorization-list']],
        ['card-list', []],
        ['card-detail', ['card-list']],
        ['account-list', []],
        ['account-detail', ['account-list']],
        ['beneficiaryservice-list', []],
        ['beneficiaryservice-detail', ['beneficiaryservice-list']],
        ['order-list', []],
        ['order-detail', ['order-list']],
        ['param-control', []],
        ['product-list', []],
        ['request-list', []],
        ['request-details', ['request-list']],
        ['request-edit', ['request-list']],
        ['product-import', []],
        ['product-export', []],
        ['product-detail', ['product-list']],
        ['product-edit', ['product-list']],
        ['product-copy', ['product-list']],
        ['product-create', []],
        ['clearing-list', []],
        ['clearing-detail', ['clearing-list']],
        ['profile-create', []],
        ['profile-list', []],
        ['profile-edit', ['profile-list']],
        ['user-create', []],
        ['user-list', []]
      ])
    }
  },
  watch: {
    $route () {
      this.breadCrumbRoutes = this.getBreadCrumbRoutes()
    }
  },

  methods: {
    getBreadCrumbRoutes () {
      const breadCrumbRoutes = []
      const currentRouteName = this.$router.currentRoute._value.name
      const parentRoutes = this.routesMap.get(currentRouteName)
      if (parentRoutes) {
        for (const parentRoute of parentRoutes) {
          const oneRoute = {
            name: parentRoute,
            label: this.$i18n.t('title.breadCrumb.'.concat(parentRoute.replace('-', '')))
          }
          breadCrumbRoutes.push(oneRoute)
        }
        breadCrumbRoutes.push({
          name: currentRouteName,
          label: this.$i18n.t('title.breadCrumb.'.concat(currentRouteName.replace('-', '')))
        })
      }

      return breadCrumbRoutes
    }
  }
}
</script>

<style scoped lang="scss">

</style>
